import AttendancePlaceConfig from "@/views/configs/attendance_place/index.vue";

export default [
  {
    path: "ilhas-atendimento",
    name: "Ilhas de atendimento",
    component: AttendancePlaceConfig,
  },
];
